import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { colors, animate } from '../../styles/theme';
import { pulse } from '../../styles/animations';
import { DragAndDrop } from '../../form';

const LabelRect = styled('div')`
  background-color: ${(props) =>
    props.strategy ? colors.cs.secondaryDark : colors.grey.secondary};
  width: 80px;
  height: 20px;
  animation: ${pulse} ${animate.pulse} infinite;
`;

const SpacingRect = styled('div')`
  background-color: transparent;
  height: 5px;
`;

const InputRect = styled('div')`
  background-color: ${(props) =>
    props.strategy ? colors.cs.secondaryDark : colors.grey.secondary};
  width: 100%;
  animation: ${pulse} ${animate.pulse} infinite;
  height: 40px;
}
`;

const TextareaRect = styled(InputRect)`
  height: 120px;
`;

const CheckboxRect = styled(LabelRect)`
  width: 20px;
  display: inline-block;
`;

const CheckboxSpacingRect = styled('div')`
  background-color: transparent;
  width: 10px;
  display: inline-block;
`;

const CheckboxLabelRect = styled(LabelRect)`
  display: inline-block;
  width: 100px;
`;

const labelDisplay = (props) => {
   
  const { withLabel } = props;

  if (withLabel) {
    return (
      <>
        <LabelRect {...props} />
        <SpacingRect {...props} />
      </>
    );
  }

  return null;
};

const placeholderPropTypes = {
  withLabel: PropTypes.bool,
  wrapperClass: PropTypes.string,
};

const placeholderDefaults = {
  withLabel: false,
  wrapperClass: '',
};

const InputPlaceholder = (props) => {
  const { wrapperClass } = props;

  return (
    <div className={wrapperClass}>
      {labelDisplay(props)}
      <InputRect {...props} />
    </div>
  );
};

InputPlaceholder.defaultProps = placeholderDefaults;
InputPlaceholder.propTypes = placeholderPropTypes;

const TextareaPlaceholder = (props) => {
  const { wrapperClass } = props;

  return (
    <div className={wrapperClass}>
      {labelDisplay(props)}
      <TextareaRect {...props} />
    </div>
  );
};

TextareaPlaceholder.defaultProps = placeholderDefaults;
TextareaPlaceholder.propTypes = placeholderPropTypes;

const CheckboxGroupPlaceholder = (props) => {
  const { wrapperClass, withLabel, checkboxes } = props;

  return (
    <div className={wrapperClass}>
      {labelDisplay(props)}
      {[...Array(checkboxes)].map((value, index) => {
        return (
          <div key={index.toString()}>
            <CheckboxRect {...props} />
            <CheckboxSpacingRect />
            {withLabel && <CheckboxLabelRect {...props} />}
          </div>
        );
      })}
    </div>
  );
};

CheckboxGroupPlaceholder.defaultProps = placeholderDefaults;
CheckboxGroupPlaceholder.propTypes = {
  withLabel: PropTypes.bool,
  wrapperClass: PropTypes.string,
  checkboxes: PropTypes.number.isRequired,
};

const DragAndDropPlaceholder = (props) => {
  const { rows, hideDeleteIcon, wrapperClass } = props;
  return (
    <div className={wrapperClass}>
      <DragAndDrop.Container
        hideDeleteIcon={hideDeleteIcon}
        onDragEnd={() => {}}
        onDelete={() => {}}
      >
        {[...Array(rows)].map((value, index) => {
          return <InputPlaceholder key={index.toString()} withLabel />;
        })}
      </DragAndDrop.Container>
    </div>
  );
};

DragAndDropPlaceholder.defaultProps = {
  rows: 3,
  hideDeleteIcon: false,
  wrapperClass: '',
};
DragAndDropPlaceholder.propTypes = {
  rows: PropTypes.number,
  hideDeleteIcon: PropTypes.bool,
  wrapperClass: PropTypes.string,
};

export {
  InputPlaceholder,
  InputRect,
  LabelRect,
  SpacingRect,
  TextareaRect,
  TextareaPlaceholder,
  CheckboxGroupPlaceholder,
  DragAndDropPlaceholder,
};
